"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { HydrationBoundary, QueryClient, QueryClientProvider, } from "@tanstack/react-query";
import { useState } from "react";
export function QueryProvider({ children, dehydratedState, }) {
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                // Stale time: data is considered fresh for 5 minutes
                staleTime: 5 * 60 * 1000,
                // Cache time: data stays in cache for 10 minutes
                gcTime: 10 * 60 * 1000,
                // Retry failed requests
                retry: 1,
                // Don't refetch on window focus in development
                refetchOnWindowFocus: process.env.NODE_ENV === "production",
            },
            mutations: {
                // Retry failed mutations once
                retry: 1,
            },
        },
    }));
    return (_jsx(QueryClientProvider, { client: queryClient, children: dehydratedState ? (_jsx(HydrationBoundary, { state: dehydratedState, children: children })) : (children) }));
}
